import React from 'react';

const AdditionalCharges = ({ register }) => {
   return (
      <>
         <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl border border-slate-800 p-5">
            <h3 className="text-sm font-semibold text-white mb-4">Additional Charges</h3>
            <div className="space-y-3">
               <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-7 h-7 rounded-lg bg-red-500/10 border border-red-500/20">
                     <span className="text-red-400 font-bold text-sm">−</span>
                  </div>
                  <input
                     type="text"
                     placeholder="Description"
                     className="flex-1 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white placeholder-slate-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                     type="number"
                     placeholder="%"
                     className="w-14 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white text-right focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                     type="number"
                     {...register('header.deductionAmount', {
                        valueAsNumber: true,
                     })}
                     placeholder="₹"
                     className="w-20 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white text-right focus:ring-1 focus:ring-blue-500"
                  />
               </div>
               <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-7 h-7 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
                     <span className="text-emerald-400 font-bold text-sm">+</span>
                  </div>
                  <input
                     type="text"
                     placeholder="Description"
                     className="flex-1 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white placeholder-slate-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                     type="number"
                     placeholder="%"
                     className="w-14 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white text-right focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                     type="number"
                     {...register('header.additionAmount', {
                        valueAsNumber: true,
                     })}
                     placeholder="₹"
                     className="w-20 bg-slate-800/50 border border-slate-700 rounded-lg px-2 py-1.5 text-xs text-white text-right focus:ring-1 focus:ring-blue-500"
                  />
               </div>
            </div>
         </div>
      </>
   );
};

export default AdditionalCharges;
